import { Component, Input, OnInit } from '@angular/core';
import { ToastService } from '@shared/modules/toast/services/toast.service';

@Component({
  selector: 'app-toast-info',
  templateUrl: './toast-info.component.html',
  styleUrls: ['./toast-info.component.scss']
})
export class ToastInfoComponent implements OnInit {
  @Input() public toast$: any;

  constructor(private toastService: ToastService) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {}

  close() {
    this.toastService.removeToast(this.toast$);
  }
}
